import React from 'react';
import SelectField from '../../../../components/forms/SelectField';
import { CONTRACT_TYPES } from '../../../../constants/settings';
import { filtersSelector } from '../../../../selectors/admin/tables';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { canAccessPerformanceInAdminSelector } from '../../../../selectors/authentication';
import { formDataSelector } from '../../../../selectors/admin/forms';
import { MODELS } from '../../../../constants/admin/settings';

const FILTER_OPTIONS = [
    { label: 'Clearance contracts', value: CONTRACT_TYPES.CLEARANCE },
    { label: 'Others', value: 'OTHERS' }
];

const FILTER_OPTIONS_PERFORMANCE = [
    { label: 'Clearance contracts', value: CONTRACT_TYPES.CLEARANCE },
    { label: 'Performance contracts', value: CONTRACT_TYPES.PERFORMANCE },
    { label: 'Others', value: 'OTHERS' }
];

const EventMailsFilter = ({ filters = {}, updateFilter, canAccessPerformance, event }) => (
    <div className="ckp-admin-search-form ckp-grid-row">
        <SelectField
            onChange={updateFilter}
            className="u-margin-right-3"
            label="Type filter"
            name="mailType"
            items={
                canAccessPerformance && event.allowPerformanceContracts ? FILTER_OPTIONS_PERFORMANCE : FILTER_OPTIONS
            }
            value={filters.mailType || ''}
        />
    </div>
);

const mapStateToProps = state => ({
    filters: filtersSelector(state),
    canAccessPerformance: canAccessPerformanceInAdminSelector(state),
    event: formDataSelector(state, { model: MODELS.EVENT })
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventMailsFilter);



// WEBPACK FOOTER //
// ./src/components/admin/forms/events/EventMailsFilter.js